import React, { useCallback, useState } from "react"
import { Modal, Grid } from "antd"
import { ResponsivePage } from "ui/ResponsivePage"
import { useNavigate } from "react-router-dom"
import GroupMenuItems from "pagesV2/pro/clients/ClientWindow/GroupManager/GroupMenuItems"
import { useDispatch, useSelector } from "react-redux"
import { getGroups } from "store/groups"
import { useTranslation } from "react-i18next"

const ClientManageGroup = () => {
  const [isGroupManagerModalVisible, setIsGroupManagerModalVisible] = useState(true)
  const navigate = useNavigate()
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()
  const isMobile = !screens.md
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const groups = useSelector((state) => state.groups?.items || [])

  const handleClose = () => {
    navigate(-1)
  }
  const handleCloseModal = () => {
    setIsGroupManagerModalVisible(!isGroupManagerModalVisible)
    navigate(-1)
  }
  const handleGroupsChange = useCallback(() => {
    dispatch(getGroups())
    setIsGroupManagerModalVisible(false)
  }, [dispatch])

  return isMobile ? (
    <ResponsivePage onBackClick={handleClose} pageTitle={t("clients.manage_groups")}>
      <GroupMenuItems onGroupsChange={handleGroupsChange} groups={groups} />
    </ResponsivePage>
  ) : (
    <Modal
      title={t("clients.manage_groups")}
      open={isGroupManagerModalVisible}
      onCancel={() => handleCloseModal()}
      footer={null}
      width={{ xxl: 800, xl: 700 }}
    >
      <GroupMenuItems onGroupsChange={handleGroupsChange} groups={groups} />
    </Modal>
  )
}

export default ClientManageGroup
